import List from '@utils/list'
import Options from '@utils/common/options'
import operation from './config/operation'

const { Search, Table, Tabs } = List

const { Select } = Search

const select = Select.use('/purchaseUnit/getPurchaseUnitPage').params({ usingFlag: '1' })

const search = new Search('performance.performancequery')
  .placeholder('searchPlaceholder')
  .add('performanceDate').merge('date').bind('format', 'yyyy-MM').bind('type', 'month')
  .add('purchaseUnitNo').select(select)

const tabs = new Tabs()
  .url('/srmPerformanceScore/getPerformanceScoreStatusCount', process.env.VUE_APP_PURCHASE_API)
  .map({ '0': '' })

const options = new Options('performance.performancequery')
  .add('1', 'status1')
  .add('2', 'status2')
  .add('3', 'status3')

const table = new Table('performance.performancequery')
  .type('index')
  .add('formulaId').name('formulaName')
  .add('purOfficeNo').name('purOfficeName')
  .add('adddate').width(150)
  .add('supOfficeNo').name('supOfficeName')
  .add('effectiveDate').date()
  .add('expirationDate').date()
  .add('revesion')
  .add('performanceDate').date('yyyy-MM')
  .add('qualitativeScore')
  .add('qualitativeWeight').format(data => data.value ? `${data.value}%` : '')
  .add('rationScore')
  .add('rationWeight').format(data => data.value ? `${data.value}%` : '')
  .add('totalScore')
  .add('adjustmentScore')
  .add('status').op(options)

export default new List()
  .url('/srmPerformanceScore/getSrmPerformanceScorePageByParams', process.env.VUE_APP_PURCHASE_API)
  .operation(operation)
  .tabs(tabs)
  .search(search)
  .table(table)
  .end()
